import React, {Component} from 'react'


class TransferExample extends Component {
    
    render() {
        return (
            <>
                Hello world!!!
            </>
        )
    }
}

export default TransferExample
